<template>
	<div class="slide yard-bio-bags zoom" v-parallax-fit="yard_bio_bags">
		<div class="photo1" ref="photo1" v-parallax-fit="photo1"></div>
		<div class="photo2" ref="photo2" v-parallax-fit="photo2"></div>
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	name: 'slide22',
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/12.jpg',
					url: 'https://www.oaklandca.gov/news/2021/new-racial-equity-analysis-confirms-oakland-is-a-hot-spot-for-lead-contamination-concentration-is-greatest-in-low-income-communities-of-color',
					link_title: {
						'en': 'New Racial Equity Analysis Confirms Oakland is a Hot-Spot for Lead Contamination',
						'es': 'Nuevo análisis de equidad racial confirma que Oakland es un punto crítico de contaminación por plomo'
					}
				},
			],
			text: {
				'en': 'Commissioned by the City’s Department of Race & Equity, the Racial Equity Impact Analysis concludes that, “Lead poisoning caused by lead paint remains a dire threat to public health, well-being, and life outcomes in Oakland and Alameda County...Lead paint hazards disproportionately affect low-income and Black, Indigenous, and Latinx communities due to the prevalence of older, dilapidated housing, which exposes children in poverty to lead paint hazards at the greatest rates.”',
				'es': 'Encargado por el Departamento de Raza y Equidad de la Ciudad, el Análisis de Impacto de Equidad Racial concluye que, “El envenenamiento por plomo causado por la pintura con plomo sigue siendo una grave amenaza para la salud pública, el bienestar y los resultados de vida en Oakland y el condado de Alameda... Pintura con plomo Los peligros afectan de manera desproporcionada a las comunidades negras, indígenas y latinas y de bajos ingresos debido a la prevalencia de viviendas antiguas y en ruinas, lo que expone a los niños en situación de pobreza a los peligros de la pintura con plomo en las tasas más altas”.'
			}
		};
		const audio = '/themes/rise-theme/resources/assets/audio/vanessa/4.mp3';
		const text = {
			'en': 'In Oakland and cities across the country, environmental racism and lead poisoning are unfortunately a common occurrence in communities of color, causing harmful health and economic impacts that last across generations.',
			'es': 'Desafortunadamente, en Oakland y en ciudades de todo el país, el racismo ambiental y el envenenamiento por plomo son algo común en las comunidades de color, lo que causa impactos nocivos en la salud y la economía que perduran de generación en generación.'
		};
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(0px) rotate(0deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$readMore.value = text;
					this.$evidence.value = JSON.stringify(evidence);
				}
			});
		});

		this.mutationObserver.observe(this.$refs.photo1, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/vanessa/4.srt',
				'es': '/themes/rise-theme/resources/assets/audio/vanessa/4_es.srt'
			},
			mutationObserver: null,
			photo1: [
				{
					start: 27700,
					end: 28300,
					fromStyle: { transform: 'translateY(-1200px) rotate(-15deg)' },
					toStyle: { transform: 'translateY(0px) rotate(0deg)' },
					easing: 'easeOutCirc'
				},
				{
					start: 28800,
					end: 29300,
					fromStyle: { transform: 'translateY(0px) rotate(0deg)' },
					toStyle: { transform: 'translateY(0px) rotate(12deg)' },
					easing: 'linear'
				}
			],
			photo2: [
				{
					start: 27800,
					end: 28300,
					fromStyle: { transform: 'translateY(-1200px) rotateZ(10deg)' },
					toStyle: { transform: 'translateY(0px) rotateZ(-8deg)' },
					easing: 'easeOutCirc'
				},
			],
			yard_bio_bags: [
				{
					start: 28800,
					end: 29300,
					fromStyle: { transform: 'translateY(0px)  rotateZ(0deg)' },
					toStyle: { transform: 'translateY(1200px) rotateZ(-12deg)' },
					easing: 'linear'
				},
			]
		};
	}
}
</script>

<style lang="scss" scoped>
.yard-bio-bags {
	transition: 0.5s;
}

.photo1 {
	position: absolute;
	transform-origin: center;
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/22_Backyard.png');
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: 720px;
	height: 600px;
	left: -392px;
	top: 44vh;
	transition: 0.3s;
	z-index: 2;
	pointer-events: none;

	@media(max-width: 600px) {
		width: 70vw;
		height: 370px;
		left: -40vw;
		top: 30vh;
	}
}

.photo2 {
	position: absolute;
	transform-origin: center;
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/22_BioBags.png');
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: 280px;
	height: 230px;
	left: -152px;
	top: 60vh;
	transition: 0.3s;
	z-index: 3;
	transform: rotate(-8deg);

	@media(max-width: 600px) {
		width: 30vw;
		height: 200px;
		left: -17vw;
		top: 37vh;
	}
}</style>
